import { render } from "./XiaoLiuRen.vue?vue&type=template&id=2f3db538&scoped=true"
import script from "./XiaoLiuRen.vue?vue&type=script&lang=js"
export * from "./XiaoLiuRen.vue?vue&type=script&lang=js"

import "./XiaoLiuRen.vue?vue&type=style&index=0&id=2f3db538&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f3db538"]])

export default __exports__